"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Pagination.default;
  }
});
Object.defineProperty(exports, "usePagination", {
  enumerable: true,
  get: function get() {
    return _usePagination.default;
  }
});

var _Pagination = _interopRequireDefault(require("./Pagination"));

var _usePagination = _interopRequireDefault(require("./usePagination"));


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/lab/Pagination/index.js
// module id = 965
// module chunks = 0